/**
 * Copyright (c) Simam Digital. Built on Project Flowerbed
 * (Copyright (c) Meta Platforms, Inc. and affiliates).
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Lightweight, DOM-based notification channel. Gameplay systems fire a
 * `garden-notify` event; the HUD listens and shows a transient toast. This
 * keeps the ECS systems decoupled from the DOM overlay.
 *
 * @param {string} message
 * @param {'info'|'success'|'error'} [type]
 */
export function notifyGarden(message, type = 'info') {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(
		new CustomEvent('garden-notify', { detail: { message, type } }),
	);
}
